import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import { DrawerHistoryFiltersForm } from './DrawerHistoryFiltersForm';

// Default State
const initialState = {
  data: null,
  isLoadingDrawerHistory: true,
  error: false,
  meta: {},
  pageSize: 15,
  currentPage: 1, // api uses page 1 as first page
};

// Action Creators and Action Types
export const FETCH_DRAWER_HISTORIES_REQUEST = 'FETCH_DRAWER_HISTORIES_REQUEST';
export const fetchDrawerHistoriesRequest = (payload) => ({
  type: FETCH_DRAWER_HISTORIES_REQUEST,
  payload,
});

export const FETCH_DRAWER_HISTORIES_SUCCESS = 'FETCH_DRAWER_HISTORIES_SUCCESS';
export const fetchDrawerHistoriesSuccess = (payload) => ({
  type: FETCH_DRAWER_HISTORIES_SUCCESS,
  payload,
});

export const FETCH_DRAWER_HISTORIES_ERROR = 'FETCH_DRAWER_HISTORIES_ERROR';
export const fetchDrawerHistoriesError = (payload) => ({
  type: FETCH_DRAWER_HISTORIES_ERROR,
  payload,
});

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const fetchUsersRequest = (payload) => ({
  type: FETCH_USERS_REQUEST,
  payload: payload,
});
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const fetchUsersSuccess = (payload) => ({
  type: FETCH_USERS_SUCCESS,
  payload,
});
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';
export const fetchUsersError = (payload) => ({
  type: FETCH_USERS_ERROR,
  payload,
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'drawerHistoryIndex/ALERT_BAR_ACTION';
export const drawerHistoryIndexAlertBarAction =
  Nested.nestedAction(ALERT_BAR_ACTION);

// Form actions & types
export const DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION =
  'drawerHistory/DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION';
export const drawerHistoryIndexFiltersFormAction = Nested.nestedAction(
  DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION,
);

export const CLEAR_SEARCH_FIELD_ACTION = 'search/CLEAR_SEARCH_FIELD_ACTION';
export const clearSearchFieldAction = Nested.nestedAction(
  CLEAR_SEARCH_FIELD_ACTION,
);

// Raw Reducer
export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_DRAWER_HISTORIES_REQUEST:
      return {
        ...state,
        data: initialState.data,
        currentPage: payload.pageIndex,
        isLoadingDrawerHistory: true,
      };
    case FETCH_DRAWER_HISTORIES_SUCCESS:
      return {
        ...state,
        data: payload.data,
        meta: payload.meta,
        isLoadingDrawerHistory: false,
      };
    case FETCH_DRAWER_HISTORIES_ERROR:
      return {
        ...state,
        isLoadingDrawerHistory: false,
      };
    case FETCH_USERS_REQUEST:
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: payload,
      };
    case FETCH_USERS_ERROR:
    case DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION:
      return {
        ...state,
        shouldClear: false,
      };
    case CLEAR_SEARCH_FIELD_ACTION:
      return {
        ...state,
        shouldClear: true,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.drawerHistoryIndex,
});
export const _mapDispatchToProps = (dispatch) => ({
  fetchData: (params) => dispatch(fetchDrawerHistoriesRequest(params)),
  clearSearchField: () => dispatch(clearSearchFieldAction()),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      drawerHistoryIndexAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
    forms: {
      drawerHistoryFiltersForm: {
        ...DrawerHistoryFiltersForm,
        actionType: DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION,
      },
    },
  },
  'drawerHistoryIndex',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
